import { UIHeading2 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './NameValueList.css';

interface INameValueListProps {
  children: React.ReactNode;
}

export function NameValueList({ children }: INameValueListProps) {
  return <dl className={styles['list']}>{children}</dl>;
}

interface INameValueListItemProps {
  name: React.ReactNode;
  value: React.ReactNode;
}

function NameValueListItem({ name, value }: INameValueListItemProps) {
  return (
    <div className={styles['item']}>
      <dt className={styles['name']}>{name}</dt>
      <dd className={styles['value']}>{value}</dd>
    </div>
  );
}

NameValueList.Item = NameValueListItem;

interface INameValueListSectionProps {
  columns?: 1 | 2;
  title?: string;
}

function NameValueListSection({ children, columns, title }: React.PropsWithChildren<INameValueListSectionProps>) {
  return (
    <section className={styles['section']}>
      {title && (
        <div className={styles['title']}>
          <UIHeading2 color="text-primary-default">{title}</UIHeading2>
        </div>
      )}
      <div className={cx(styles['grid'], columns === 2 && styles['grid-2'])}>{children}</div>
    </section>
  );
}

NameValueList.Section = NameValueListSection;
